import React, { Component } from 'react';
import ActionBar from '../../ActionBar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { snakeCase } from 'lodash';
import { saveAsDraft } from 'redux/ducks/Post/actions';
import { suppliesFieldChange } from 'redux/ducks/Post/Locations/actions';
import {
  findOtherIndex,
  lastOtherIndex,
  otherCredentials,
  rebuildPostWithoutEmptyCredentials,
  splitCredentialName,
  SUGGESTED_ADDITIONAL_CREDENTIALS,
  suggestedCredentials,
  trackMixpanelPageView,
} from 'helpers/post';
import { createSession } from 'redux/ducks/Session';
import RequiredCredential from './RequiredCredential';
import AdditionalCredential from './AdditionalCredential';
import { AddButton } from 'components/V2/Buttons';

class RequiredCredentials extends Component {
  constructor(props) {
    super(props);
    props.initialize('Credentials');

    this.state = {
      collapseAdditionalCredentials: false,
      errors: {},
    };
  }

  componentDidMount() {
    if (!this.props.editMode) trackMixpanelPageView('create-event/details/credentials', this.props.user);
    if (this.addFirstCredential())
      this.props.onSuppliesChange(this.props.locationIdx, 'requiredCredentials', ['false - Other[0] - ']);
  }

  addFirstCredential = () => {
    const { editMode } = this.props;
    const otherCredentials = this.otherCredentials();

    return !editMode && otherCredentials.length === 0;
  };

  toggleAdditionalCredentialsCollapse = () => {
    this.setState(prevState => ({
      ...prevState,
      collapseAdditionalCredentials: !prevState.collapseAdditionalCredentials,
    }));
  };

  validatePage = setState => {
    const otherCredentials = this.otherCredentials();
    const errors = {};

    otherCredentials.forEach(cred => {
      if (!this.credentialValid(cred)) {
        errors[cred] = 'Cannot be blank';
      }
    });

    if (setState) {
      this.setState(prevState => ({
        ...prevState,
        errors,
      }));
    }

    return errors;
  };

  pageIsValid = (setState = false) => {
    const errors = this.validatePage(setState);

    return Object.keys(errors).length === 0;
  };

  credentialValid = name => {
    if (name.startsWith('false - Other[')) return true;

    return name.startsWith('true - Other[') && splitCredentialName(name) !== '';
  };

  onSaveAndContinue = () => {
    if (!this.pageIsValid(true)) return;

    const { baseUrl, post, authenticated } = this.props;
    if (!authenticated) return;

    const callback = () => {
      this.props.history.push(`${baseUrl}/eap/eap-type`);
    };
    const rebuildPost = rebuildPostWithoutEmptyCredentials(post);

    this.props.saveAsDraft(rebuildPost, callback);
  };

  onAddCredential = index => {
    const { supplies } = this.props.shiftLocation;

    const newCredentials = [...supplies.requiredCredentials];
    newCredentials.push(`false - Other[${index}] - `);

    this.props.onSuppliesChange(this.props.locationIdx, 'requiredCredentials', newCredentials);
  };

  toggleCredential = event => {
    const { checked, name } = event.target;

    if (checked) {
      this.onToggleAddNewCredential(name);
    } else {
      this.onToggleRemoveCredential(name);
    }
  };

  toggleOptionalCredential = event => {
    const { name } = event.target;
    const otherCredentials = this.otherCredentials();
    const credIndex = otherCredentials.findIndex(cred => cred === name);
    const credential = otherCredentials[credIndex];

    if (!credential) return;

    if (credential.startsWith('false - ')) this.onCheckOtherCredential(name);
    if (credential.startsWith('true - ')) this.onToggleRemoveCredential(name);
  };

  onToggleAddNewCredential = name => {
    const { supplies } = this.props.shiftLocation;
    const newCredentials = [...supplies.requiredCredentials, name];
    this.props.onSuppliesChange(this.props.locationIdx, 'requiredCredentials', newCredentials);
  };

  onToggleRemoveCredential = name => {
    const { supplies } = this.props.shiftLocation;
    const newCredentials = supplies.requiredCredentials.filter(cred => cred !== name);
    this.props.onSuppliesChange(this.props.locationIdx, 'requiredCredentials', newCredentials);
  };

  onCheckOtherCredential = name => {
    const otherCredentials = this.otherCredentials();
    const credIndex = otherCredentials.findIndex(cred => cred === name);
    const credential = otherCredentials[credIndex];
    const newCredential = credential.replace('false -', 'true -');
    otherCredentials[credIndex] = newCredential;

    this.props.onSuppliesChange(this.props.locationIdx, 'requiredCredentials', [
      ...suggestedCredentials(this.requiredCredentials()),
      ...otherCredentials,
    ]);
  };

  onChangeOtherCredential = (event, index) => {
    const { value } = event.target;
    const otherCredentials = this.otherCredentials();
    const newOtherCredential = `true - Other[${index}] - ${value}`;
    const credIndex = otherCredentials.findIndex(cred => cred.startsWith(`true - Other[${index}] - `));

    if (credIndex === -1) return;

    otherCredentials[credIndex] = newOtherCredential;
    this.props.onSuppliesChange(this.props.locationIdx, 'requiredCredentials', [
      ...suggestedCredentials(this.requiredCredentials()),
      ...otherCredentials,
    ]);
  };

  otherCredentials = () => {
    const credentials = otherCredentials(this.requiredCredentials());

    if (credentials.length === 0) return ['false - Other[0] - '];

    return this.normalizeAdditionalCredentials(credentials);
  };

  normalizeAdditionalCredentials = credentials => {
    return credentials.map((cred, index) => {
      const lastIndex = lastOtherIndex(otherCredentials(this.requiredCredentials()));

      if (cred.startsWith('Other - ')) return `true - Other[${lastIndex + 1}] - ${cred.split('Other - ')[1]}`;
      if (cred.includes(' - Other[')) return cred;

      return `true - Other[${index}] - ${cred}`;
    });
  };

  showAddCredentialButton = () => {
    const otherCredentials = this.otherCredentials();
    return otherCredentials.every(cred => cred.startsWith('true - '));
  };

  requiredCredentials = () => {
    return this.props.shiftLocation.supplies.requiredCredentials;
  };

  render() {
    const otherCredentials = this.otherCredentials();

    return (
      <div className="requiredCredentials ">
        <div id="attribution"></div>
        <main>
          <header>
            <div className="screen-title">Credentials</div>
          </header>
          <div className="requiredCredentialsContainer">
            <div className="subheader-text">
              <p className="subheader-title gotham-bold-font">Required by Go4</p>
              <p className="subheader-notice gotham-medium-font">
                Athletic trainers must meet national and state requirements to provide care.
              </p>
            </div>

            <div className="required-credentials">
              <RequiredCredential
                title="Board Certification"
                id="boc_certificate"
                toolTipText="Confirms national certification by the Board of Certification, including CPR, AED, and emergency care competencies."
              />
              <RequiredCredential
                title="State License/Certification"
                id="state_certificate"
                toolTipText="Verifies an active license or certification in the state of practice, as required by law."
              />
              <RequiredCredential
                title="Professional Liability Insurance"
                id="professional_liability_insurance"
                toolTipText="Go4 requires a minimum coverage amount of $1M incident / $3M aggregate for exposures related to services as an athletic trainer."
              />
            </div>

            <div className="additional-credentials">
              <div className="handler" onClick={this.toggleAdditionalCredentialsCollapse}>
                <h4 className="gotham-bold-font">Add Requirements (Optional)</h4>
                <h4 className="gotham-bold-font">{this.state.collapseAdditionalCredentials ? '-' : '+'}</h4>
              </div>
              <div
                className={classNames('collapse', {
                  selected: this.state.collapseAdditionalCredentials,
                })}
              >
                <p className="gotham-medium-font notice-text">
                  It's your responsibility to verify that their credentials match the needs of your job. You
                  can review all applicants' credentials before choosing who to hire.
                </p>

                {SUGGESTED_ADDITIONAL_CREDENTIALS.map(credential => {
                  return (
                    <AdditionalCredential
                      key={snakeCase(credential)}
                      id={snakeCase(credential)}
                      name={credential}
                      checked={suggestedCredentials(this.requiredCredentials()).find(
                        cred => cred === credential
                      )}
                      onClick={this.toggleCredential}
                      title={credential}
                      suggested
                    />
                  );
                })}

                {otherCredentials.map(cred => {
                  const credIndex = findOtherIndex(cred);

                  return (
                    <AdditionalCredential
                      key={`other_credentials_${credIndex}`}
                      id={`other_credential_${credIndex}`}
                      name={cred}
                      value={splitCredentialName(cred)}
                      checked={cred.startsWith('true - ')}
                      onClick={this.toggleOptionalCredential}
                      onChange={event => this.onChangeOtherCredential(event, credIndex)}
                      error={this.state.errors[cred]}
                    />
                  );
                })}

                {this.showAddCredentialButton() && (
                  <AddButton onClick={() => this.onAddCredential(lastOtherIndex(otherCredentials) + 1)}>
                    +ADD
                  </AddButton>
                )}
              </div>
            </div>
          </div>
          <ActionBar
            disableFlash
            editMode={this.props.editMode}
            backTo={`${this.props.baseUrl}/details/details`}
            nextDisabled={() => !this.pageIsValid(false)}
            currentStep="details/credentials"
            onSaveAndContinue={this.onSaveAndContinue}
          />
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { post } = state;
  const { locationIdx } = post.navigation;
  const shiftLocation = post.locations[locationIdx];

  return {
    post,
    authenticated: state.session.authenticated,
    locationIdx,
    shiftLocation,
    user: state.session.currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  saveAsDraft: (post, callback) => dispatch(saveAsDraft({ post, callback, from: 'credentials' })),
  onSuppliesChange: (locationIndex, name, value) =>
    dispatch(suppliesFieldChange({ locationIndex, name, value })),
  login: credentials => dispatch(createSession(credentials)),
  saveProfile: (post, callback) => dispatch(saveAsDraft({ post, callback, from: 'credentials' })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequiredCredentials));
